"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _ssrWindow = require("ssr-window");

var _each = _interopRequireDefault(require("lodash/each"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _some = _interopRequireDefault(require("lodash/some"));

var _storage = _interopRequireDefault(require("../storage/storage"));

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var makeTrackingCall = function makeTrackingCall(_ref) {
  var event = _ref.event,
      properties = _ref.properties,
      _ref$additionalOption = _ref.additionalOptions,
      additionalOptions = _ref$additionalOption === void 0 ? null : _ref$additionalOption,
      _ref$callback = _ref.callback,
      callback = _ref$callback === void 0 ? null : _ref$callback;

  if (_ssrWindow.window.analytics && !(0, _isFunction.default)(_ssrWindow.window.analytics.track)) {
    return;
  }

  _ssrWindow.window.analytics.track(event, properties, additionalOptions, callback);
};

var logTrackingCall = function logTrackingCall(_ref2) {
  var _context, _context2;

  var event = _ref2.event,
      properties = _ref2.properties,
      _ref2$additionalOptio = _ref2.additionalOptions,
      additionalOptions = _ref2$additionalOptio === void 0 ? null : _ref2$additionalOptio,
      _ref2$callback = _ref2.callback,
      callback = _ref2$callback === void 0 ? null : _ref2$callback;
  console.log((0, _concat.default)(_context = (0, _concat.default)(_context2 = "Segment - Track: ".concat(event, ", Properties: ")).call(_context2, (0, _stringify.default)(properties, null, 4), ", Additional Options: ")).call(_context, (0, _stringify.default)(additionalOptions, null, 4))); // eslint-disable-line no-console

  if (callback) {
    callback();
  }
};

var postReady = function postReady(onLoad) {
  var clientFingerprint = _storage.default.get('sh-client-fingerprint', 'cookie');

  var segmentAnonymousId = _storage.default.get('ajs_anonymous_id', 'cookie');

  if (!(0, _isNil.default)(clientFingerprint) && !(0, _isNil.default)(segmentAnonymousId) && clientFingerprint !== segmentAnonymousId) {
    _ssrWindow.window.analytics.user().anonymousId(clientFingerprint);
  }

  if ((0, _isFunction.default)(onLoad)) {
    onLoad();
  }
};

var segmentQueue = [];
var debugMode = false;
var loadInterval;
/**
 * Utilities for working with Segment.
 * @module SegmentUtils
 */

var SegmentUtils = {
  /**
   * Loads and initializes Segment's analytics.js library.
   * @static
   * @function init
   * @param {Object} data - The data used to initialize Segment.
   * @param {String} data.apiKey - The Segment API key.
   * @param {Function} [data.onLoad] - A callback function to execute once all enabled destinations have loaded and Segment has completed initialization.
   * @param {Boolean} [data.debug=false] - Puts SegmentUtils into debug mode and just logs all events to the console.
   * @example
   * SegmentUtils.init({apiKey: 'ABCDEFG'});
   * @returns {void}
   */
  init: function init(_ref3) {
    var apiKey = _ref3.apiKey,
        onLoad = _ref3.onLoad,
        _ref3$debug = _ref3.debug,
        debug = _ref3$debug === void 0 ? false : _ref3$debug;

    if ((0, _isNil.default)(apiKey)) {
      throw new Error("Missing required argument \"apiKey\".");
    }

    if (!debug) {
      /* eslint-disable */
      !function () {
        var analytics = _ssrWindow.window.analytics = _ssrWindow.window.analytics || [];
        if (!analytics.initialize) if (analytics.invoked) _ssrWindow.window.console && console.error && console.error("Segment snippet included twice.");else {
          analytics.invoked = !0;
          analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "user"];

          analytics.factory = function (t) {
            return function () {
              var e = (0, _slice.default)(Array.prototype).call(arguments);
              e.unshift(t);
              analytics.push(e);
              return analytics;
            };
          };

          for (var t = 0; t < analytics.methods.length; t++) {
            var e = analytics.methods[t];
            analytics[e] = analytics.factory(e);
          }

          analytics.load = function (t) {
            var e = document.createElement("script");
            e.type = "text/javascript";
            e.async = !0;
            e.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
            var n = document.getElementsByTagName("script")[0];
            n.parentNode.insertBefore(e, n);
          };

          analytics.SNIPPET_VERSION = "4.0.0";

          _ssrWindow.window.analytics.load(apiKey);

          _ssrWindow.window.analytics.ready(postReady);
        }
      }();
      /* eslint-enable */
    } else {
      debugMode = true;

      if ((0, _isFunction.default)(onLoad)) {
        onLoad();
      }
    }
  },

  /**
   * Associates users and their actions to a recognizable user ID and traits.
   * @static
   * @function identify
   * @param {Object} data - The data to associate to the user.
   * @param {String} data.uniqueId - The ID for the user.
   * @param {Object} [data.traits] - A dictionary of traits about the user.
   * @example
   * SegmentUtils.identify({
   *     uniqueId: 'userId123'
   *     traits: {
   *         email: user.email,
   *         created: user.dateJoined,
   *         name: user.displayName,
   *     }
   * });
   * @returns {void}
   */
  identify: function identify(_ref4) {
    var uniqueId = _ref4.uniqueId,
        traits = _ref4.traits;

    if ((0, _isNil.default)(uniqueId)) {
      throw new Error("Missing required argument \"uniqueId\".");
    }

    var stringUniqueId = uniqueId.toString();

    if (!debugMode) {
      if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
        return;
      }

      if (stringUniqueId && traits) {
        _ssrWindow.window.analytics.identify(stringUniqueId, traits);
      } else {
        _ssrWindow.window.analytics.identify(stringUniqueId);
      }
    } else {
      console.log('Segment - Identify:', stringUniqueId, ', Traits: ', traits); // eslint-disable-line no-console
    }
  },

  /**
   * Combines two previously unassociated user identities.
   * @static
   * @function alias
   * @param {Object} data - The data to associate to the user.
   * @param {String} data.uniqueId - The ID for the user.
   * @param {Object} [data.previousId] - The previous ID of the user.
   * @example
   * SegmentUtils.alias({
   *     uniqueId: 'userId123'
   *     previousId: 'userId456'
   * });
   * @returns {void}
   */
  alias: function alias(_ref5) {
    var uniqueId = _ref5.uniqueId,
        previousId = _ref5.previousId;

    if ((0, _isNil.default)(uniqueId)) {
      throw new Error("Missing required argument \"uniqueId\".");
    }

    if (!debugMode) {
      if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
        return;
      }

      if (uniqueId && previousId) {
        _ssrWindow.window.analytics.alias(uniqueId, previousId);
      } else {
        _ssrWindow.window.analytics.alias(uniqueId);
      }
    } else {
      console.log('Segment - Alias:', uniqueId, ', Previous ID: ', previousId); // eslint-disable-line no-console
    }
  },

  /**
   * Sends page data to Segment.
   * @static
   * @function page
   * @param {Object} [data={}] - The data to send to Segment.
   * @param {String} [data.name=null] - The page name.
   * @param {Object} [data.properties=null] - The page properties object. See the properties object information <a href="https://segment.com/docs/spec/page/#properties" target="_blank">here</a> for details.
   * @param {Function} [data.callback=null] - A function that is executed after a short timeout, giving the browser time to make outbound requests first.
   * @example
   * SegmentUtils.page({
   *     name: 'Search',
   *     properties: {
   *         path: '/search'
   *     }
   * });
   * @returns {void}
   */
  page: function page() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref6$name = _ref6.name,
        name = _ref6$name === void 0 ? null : _ref6$name,
        _ref6$properties = _ref6.properties,
        properties = _ref6$properties === void 0 ? null : _ref6$properties,
        _ref6$additionalOptio = _ref6.additionalOptions,
        additionalOptions = _ref6$additionalOptio === void 0 ? null : _ref6$additionalOptio,
        _ref6$callback = _ref6.callback,
        callback = _ref6$callback === void 0 ? null : _ref6$callback;

    if (!debugMode) {
      var _window$analytics, _context3;

      if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
        return;
      }
      /*
          An empty `page` call is translated by Segment as:
          window.analytics.page('Default Page Name', {
              title: 'Default Page Title',
              url: 'Default full url',
              path: 'Default path',
              referrer: 'Default referrer'
          });
           Otherwise, page name and properties can be overridden together or separately.
      */


      (_window$analytics = _ssrWindow.window.analytics).page.apply(_window$analytics, (0, _toConsumableArray2.default)((0, _filter.default)(_context3 = [name, properties, !properties && additionalOptions ? {} : null, // additionalOptions must be passed as the second object even if there are no properties
      additionalOptions, callback]).call(_context3, Boolean)));
    } else {
      /* eslint-disable no-console */
      console.log('Segment - Page:', {
        page: name || 'Default Page Name',
        properties: properties || 'Default Page Properties',
        additionalOptions: additionalOptions || 'Default Additional Options'
      });
      /* eslint-enable no-console */

      if (callback) {
        callback();
      }
    }
  },

  /**
   * Sends tracking event data to Segment.
   * @static
   * @function track
   * @param {Object} [data={}] - The data to send to Segment.
   * @param {String} data.event - The event name.
   * @param {Object} [data.properties=null] - The event properties object. See the properties object information <a href="https://segment.com/docs/spec/track/#properties" target="_blank">here</a> for details.
   * @param {Object} [data.additionalOptions=null] - Additional options to send with the event.
   * @param {Function} [data.callback=null] - A function that is executed after a short timeout, giving the browser time to make outbound requests first.
   * @example
   * SegmentUtils.track({
   *     event: 'Searched',
   *     properties: {
   *         city: 'Chicago'
   *     }
   * });
   * @returns {void}
   */
  track: function track(data) {
    if ((0, _isNil.default)(data) || (0, _isArray.default)(data) && (0, _some.default)(data, function (_ref7) {
      var event = _ref7.event;
      return (0, _isNil.default)(event);
    }) || !(0, _isArray.default)(data) && (0, _isNil.default)(data.event)) {
      throw new Error("Missing required argument \"event\".");
    }

    if (!debugMode) {
      if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
        if ((0, _isArray.default)(data)) {
          (0, _concat.default)(segmentQueue).call(segmentQueue, data);
        } else {
          segmentQueue.push(data);
        }

        if (!loadInterval) {
          loadInterval = _ssrWindow.window.setInterval(function () {
            if (!_ssrWindow.window.analytics) {
              return;
            }

            _ssrWindow.window.clearInterval(loadInterval);

            (0, _each.default)(segmentQueue, function (item, i) {
              SegmentUtils.track(item);

              if (i === segmentQueue.length - 1) {
                segmentQueue = [];
              }
            });
          }, 100);
        }

        return;
      }

      if ((0, _isArray.default)(data)) {
        (0, _each.default)(data, function (trackingCall) {
          makeTrackingCall(trackingCall);
        });
      } else {
        makeTrackingCall(data);
      }
    } else {
      if ((0, _isArray.default)(data)) {
        (0, _each.default)(data, function (trackingCall) {
          logTrackingCall(trackingCall);
        });
      } else {
        logTrackingCall(data);
      }
    }
  },

  /**
   * A function to execute once all enabled destinations have loaded and Segment has completed initialization.
   * @static
   * @function onReady
   * @param {Function} cb - The function to execute.
   * @example
   * SegmentUtils.onReady(() => {
   *     console.log('Segment is ready!');
   * });
   * @returns {void}
   */
  onReady: function onReady(cb) {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return;
    }

    if (!debugMode) {
      if ((0, _isFunction.default)(cb)) {
        _ssrWindow.window.analytics.ready(cb);
      }
    } else {
      if ((0, _isFunction.default)(cb)) {
        cb();
      }
    }
  },

  /**
   * Allows consumers of the util to get the anonymous id if the user have been identified or not.
   * @static
   * @function getAnonymousId
   * @example
   * SegmentUtils.getAnonymousId();
   * @returns {(String|null)} Returns the segment anonymous ID, null if there was a problem
   */
  getAnonymousId: function getAnonymousId() {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return null;
    }

    var user = _ssrWindow.window.analytics.user();

    var anonymousId = (0, _isFunction.default)(user.anonymousId) ? user.anonymousId() : null;
    return anonymousId;
  },

  /**
   * Allows consumers of the util to get the segment user id
   *
   * Segment will return the anonymous ID until a `identify` occurs, after that point the
   * user id supplied in to `identify` will be returned.
   * @static
   * @function getId
   * @example
   * SegmentUtils.getId();
   * @returns {(String|null)} Returns the segment user ID, null if there was a problem
   */
  getId: function getId() {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return;
    }

    var user = _ssrWindow.window.analytics.user();

    var id = (0, _isFunction.default)(user.id) ? user.id() : null;
    var anonymousId = this.getAnonymousId();
    return !(0, _isNil.default)(id) ? id : anonymousId;
  },

  /**
   * Allows consumers of the util to call the segment reset.
   *
   * @static
   * @function reset
   * @example
   * SegmentUtils.reset();
   * @returns {void}
   */
  reset: function reset() {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return null;
    }

    _ssrWindow.window.analytics.reset();
  }
};
var _default = SegmentUtils;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(makeTrackingCall, "makeTrackingCall", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/segment/segment.js");
  reactHotLoader.register(logTrackingCall, "logTrackingCall", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/segment/segment.js");
  reactHotLoader.register(postReady, "postReady", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/segment/segment.js");
  reactHotLoader.register(segmentQueue, "segmentQueue", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/segment/segment.js");
  reactHotLoader.register(debugMode, "debugMode", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/segment/segment.js");
  reactHotLoader.register(loadInterval, "loadInterval", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/segment/segment.js");
  reactHotLoader.register(SegmentUtils, "SegmentUtils", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/segment/segment.js");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/segment/segment.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();